import PropTypes from 'prop-types';
import { Popover } from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';

const ArrowStyle = styled('span')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    content: "''",
    position: 'absolute',
    top: -8,
    right: 20,
    height: 12,
    width: 12,
    transform: 'rotate(-135deg)',
    borderRadius: '0 0 4px 0',
    borderRight: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
    borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
    background: theme.palette.background.paper,
    zIndex: 0 // if superior, it will overlay MenuItem ripple effect (ugly)
  }
}));

const MenuPopover = ({ children, sx, ...other }) => {
  const theme = useTheme();

  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{ sx: styleMenu(theme, sx) }}
      {...other}
    >
      <ArrowStyle className="arrow" />
      {children}
    </Popover>
  );
};

const styleMenu = (theme, sx) => ({
  minWidth: 200,
  ...sx
});

MenuPopover.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object
};

export default MenuPopover;
